import api from '@/services/api/checkEmail';
import { useState } from 'react'

const useAuthLogin = () => {

	const [authError, setAuthError] = useState()

	async function getAuthorizationURL(parameter) {
		const [authError, response] = await api.index(parameter);
		if (authError) {
			return setAuthError("Error in getting the Auth URL");
		}
		return response
	}

	return {
		authError,
		getAuthorizationURL
	}
}

export default useAuthLogin
